/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllUniversalImporterPlans = (state) => values(get(state, ['universalImporterPlans', 'items']));

export const requestingUniversalImporterPlans = (state) => get(state, ['universalImporterPlans', 'requesting']);

export const errorRequestingUniversalImporterPlans = (state) => get(state, ['universalImporterPlans', 'error']);